/* eslint-disable @typescript-eslint/unbound-method */
import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';

import fetchReferences from './actions/fetchReferences';
import type { ReferenceItem } from './types';

export const referencesAdapter = createEntityAdapter<ReferenceItem>({
  selectId: reference => reference.id,
});

export const referencesSlice = createSlice({
  name: 'references',
  initialState: referencesAdapter.getInitialState(),
  reducers: {
    addReference: referencesAdapter.addOne,
    addReferences: referencesAdapter.addMany,
    removeReference: referencesAdapter.removeOne,
    removeReferences: referencesAdapter.removeMany,
  },
  extraReducers: builder => {
    builder.addCase(fetchReferences.fulfilled, (state, action) => {
      referencesAdapter.setAll(state, action.payload);
    });
  },
});

export default referencesSlice.reducer;
